{
  "Users": "Användare",
  "UsersEmpAndActive": "Totala användare / SEB-Anställda",
  "Progressing User": "Användare som gjort progress",
  "Completing Users between": "Användare som avslutat en kurs mellan {{date}} och {{date2}}",
  "Progressing Users between": "Användare som har gjort progress mellan {{date}} och {{date2}}",
  "User Population Overview": "Översikt över användare",
  "Sum of all user accounts": "Totalt antal användare",
  "Population": "Population",

  "progressing-user-definition": "Antal användare som gjort minst ett framsteg",
  "Completing User": "Användare som slutfört",
  "completing-user-definition": "Användare som slutfört minst ett lärobjekt",

  "users": "Användare",
  "total-users-definition": "Totalt antal användare",
  "registered-users-definition": "Totalt antal registrerade användare",
  "pending-users-definition": "Totalt antal användare med status 'pending'",
  "incomplete-users-definition": "Användare som saknar komplett användarkonto",
  "deactivated-users-definition": "Användare som blivit deaktiverade",

  "completions-over-time-definition": "Antal slutförda kurser över tid",
  "total-effort-definition": "Tid investerad",

  "average-effort-per-user-definition": "Genomsnittlig tid per användare",
  "completions-definition": "Alla gånger kursen blivit slutförd, max en gång per användare",
  "participants-definition": "Antal användare som gjort framsteg i kursen",
  "completion-rate-definition": "Antal användare som slutfört kursen dividerat med antal som gjort framsteg i kursen",
  "Completion Rate": "Completion Rate",
  "Average Effort Per User": "Genomsnittlig tid per användare",
  "total-user-count-definition": "Totalt antal användare",
  "Total Effort": "Total investerad tid",
  "Number of completions per day over time": "Antal slutförda kurser per dag över tid",
  "Completions over time": "Slutförda lärobjekt över tid",
  "Total User Count": "Totalt antal användare",
  "Info": "Info",
  "Dashboard": "Översikt",
  "To": "Till",
  "From": "Från",
  "And": "och",
  "Effort over time": "Progress över tid",
  "Effort-over-time-definition": "Framsteg som användare har gjort över tid (i timmar)",

  "HR-data": "HR-data",
  "total-users": "{{count}} Användare",
  "active-users": "{{count}} Aktiva användare",
  "completing-users": "{{count}} Användare som slutfört",
  "Popular Courses": "Populära kurser",
  "popular-courses-definition": "Kurser sorterade efter flest antal slutförda",
  "hours": "{{count}} timmar",

  "Content": "Content",
  "Title": "Titel",
  "Completion rate": "Andel avslutade",
  "Participants": "Deltagare",
  "Completions": "Avslutade",
  "Clear filters": "Rensa filter",
  "Completion": "Avslutat",
  "Analyze": "Analysera",
  "Download report": "Ladda ner rapport",
  "Download extended report": "Ladda ner utökad rapport",
  "Select file format": "Välj filformat",
  "Progress": "Pågående",
  "User statistics": "Användarstatistik",
  "Analytics": "Analys",
  "items-selected": "{{ count }} OBJEKT VALT",
  "items-selected_plural": "{{ count }} OBJEKT VALDA",
  "No title": "Ingen titel (id: {{ id }})",
  "Show Campus Online": "Visa Campus Online",

  "Email": "Email",
  "First activity": "Första aktivitet",
  "Last activity": "Senaste aktivitet",
  "Completed":  "Avslutade",
  "Started": "Påbörjade",
  "Total effort (hours)": "Total tidsåtgång (timmar)",

  "status": "Status",
  "registered": "Registrerad",
  "in-progress": "Progress",
  "completed": "Avklarad",
  "expired": "Utgången"
}
